import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "@/components/base/Button";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "L'association", to: "/association" },
  { label: "Nos actions", to: "/actions" },
  { label: "Nos réalisations", to: "/realisations" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { settings } = useSiteSettings();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome || open;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-8 lg:px-10 h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          {settings?.logo ? (
            <img
              src={settings.logo}
              alt={settings.association_name || "Logo"}
              style={{ height: `${settings.logo_height || 40}px` }}
              className="w-auto object-contain"
            />
          ) : (
            <>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span
                className={`font-heading text-xl font-bold ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                Humanity<span className="text-primary-500">59</span>
              </span>
            </>
          )}
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors rounded-full cursor-pointer ${
                  active
                    ? "bg-primary-100 text-primary-700"
                    : solid
                    ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:block">
          <Button to="/don" variant="primary" className="px-5 py-2.5">
            <i className="ri-heart-3-line"></i>
            Faire un don
          </Button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
            solid ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium cursor-pointer ${
                    active
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
          <Button to="/don" variant="primary" className="w-full mt-3">
            <i className="ri-heart-3-line"></i>
            Faire un don
          </Button>
        </div>
      )}
    </header>
  );
}